<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import GenericLink from '../link-generic/GenericLink'
import { GenericLinkData } from '../link-generic/GenericLinkData'
import { PuBookingLinkProps } from './PuBookingLinkProps'
import { isUndefined } from 'lodash-es'

@Component({
  mixins: [GenericLink],
})
class PuBookingLink extends Vue implements PuBookingLinkProps {
  @Prop()
  campsiteSlug: string

  @Prop({ required: false, default: () => [] })
  categoryIds: string[]

  @Prop()
  dateRange: { start: string; end: string }

  @Prop()
  chargetypeId: string

  @Prop()
  pitchtypeId: string

  @Prop()
  party: {
    adults: number
    childAges: number[]
    dogs?: number
  }

  @Prop({ default: 'booking' })
  excludeType?: string

  get linkData(): GenericLinkData {
    const data = {
      path: `/campsite/${this.campsiteSlug}/book/`,
      query: {
        arrive: this.dateRange.start,
        depart: this.dateRange.end,
        pitchtype: this.pitchtypeId,
        chargetype: this.chargetypeId,
        adults: this.party.adults.toString(),
        child_ages: this.party.childAges.join(','),
        dogs: !isUndefined(this.party.dogs)
          ? this.party.dogs.toString()
          : undefined,
        type: this.categoryIds,
      },
    }
    return data
  }
}

export default toNative(PuBookingLink)
</script>
